
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 600 300"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#00abc9","d":"M0 0h600v300H0z"}}),_c('path',{attrs:{"fill":"#fae042","d":"M0 100h600v100H0z"}}),_c('path',{attrs:{"d":"M0 0v300l259.808-150z"}})])
          )
        }
      }
    